import { AIRPORT_KEY } from '../constants/categoryConstants';

export const getDisplayName = (smartFillLocationObject, key) => {
  const {
    name,
    address,
    provinceName: province,
    countryName: country,
    cityName: city,
  } = smartFillLocationObject;
  const cityName = address?.cityName || city;
  const provinceName = address?.provinceName || province;
  const countryName = address?.countryName || country;
  const cityOrProvinceName = key === AIRPORT_KEY ? cityName : provinceName;
  const displayNameParts = [name, cityOrProvinceName, countryName];
  return displayNameParts.filter(Boolean).join(', ');
};

export const getFlightsDisplayName = (smartFillLocationObject, key) => {
  const {
    name,
    address,
    provinceName: province,
    countryName: country,
    cityName: city,
    code,
  } = smartFillLocationObject;
  const cityName = address?.cityName || city;
  const provinceName = address?.provinceName || province;
  const countryName = address?.countryName || country;
  const displayNameParts = key === AIRPORT_KEY ? [`${cityName} (${code} - ${name})`, provinceName, countryName] : [name, provinceName, countryName];
  return displayNameParts.filter(Boolean).join(', ');
};
